module.exports = __webpack_public_path__ + "static/img/45.dcbc2c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/45.png
// module id = 0tRH
// module chunks = 0